export default {
  welcome: 'ようこそ',
  subtitle: 'アカウントとパスワードを入力してください',
  email: 'アカウント',
  emailPlaceholder: 'アカウントを入力してください',
  password: 'パスワード',
  passwordPlaceholder: 'パスワードを入力してください',
  or: 'または',
  noAccount: 'アカウントをお持ちでない場合',
  contactAdmin: '管理者に連絡してください',
  forgotPasswordTip: 'パスワードを忘れた場合は、管理者に連絡してください',
  contactAdminTip: 'アカウントを作成する必要がある場合は、管理者に連絡してください',
};
